export default "__VITE_ASSET__BfoUdWVn__"